import { Stack, Box } from "@mui/material"

export default function LineaRoja() {
  return (
    <Stack
      sx={{
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          height: "5px",
          width: "90%",
          backgroundColor: "#B71234",
          borderRadius: "10px",
        }}
      />
    </Stack>
  )
}
